import { useEffect, useState } from "react";
import api from "@/lib/api";
import { AppShell } from "@/components/AppShell";
import { Users, MessageSquare, Sparkles, Crown } from "lucide-react";

export default function AdminHome() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const items = [
    { label: "Toplam Kullanıcı", value: stats?.total_users, icon: Users },
    { label: "Öğrenci", value: stats?.total_students, icon: Sparkles },
    { label: "Premium Üye", value: stats?.total_premium, icon: Crown },
    { label: "Toplam Sohbet", value: stats?.total_conversations, icon: MessageSquare },
    { label: "Toplam Mesaj", value: stats?.total_messages, icon: MessageSquare },
  ];

  return (
    <AppShell variant="admin">
      <div className="max-w-5xl mx-auto p-5 lg:p-10" data-testid="admin-home">
        <div className="text-xs font-semibold text-[#1E3A8A] uppercase tracking-wider">Yönetim</div>
        <h1 className="mt-2 font-display text-3xl font-bold tracking-tight text-zinc-900">
          Genel İstatistikler
        </h1>
        <p className="mt-2 text-zinc-600">SuperZeka platformunun anlık özeti.</p>

        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((it) => (
            <div
              key={it.label}
              className="rounded-2xl border border-zinc-200 bg-white p-5"
              data-testid={`stat-${it.label}`}
            >
              <div className="flex items-center justify-between">
                <div className="text-xs text-zinc-500">{it.label}</div>
                <it.icon className="w-4 h-4 text-[#1E3A8A]" />
              </div>
              <div className="mt-2 font-display text-3xl font-bold text-zinc-900">
                {it.value ?? "—"}
              </div>
            </div>
          ))}
        </div>
      </div>
    </AppShell>
  );
}
